import React, { useState, useEffect } from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import { connect } from 'react-redux';
import { goToPage, setTitle , getAoc, purchaseSong, setErrorType, pageLoaded, getSubscribers, reportAnalytics} from '../fundialSlice';
import SongSubscriptionSelector from '../Shared/SongSubscriptionSelector/SongSubscriptionSelector'
import { showAppLoader, hideAppLoader } from '../../../Shared/Loader/LoaderSlice';
import BusinessDownloadSongPopUp from '../Shared/BusinessDownloadSongPopUp/businessDownloadSongPopUp'
import TermsPopUp from '../Shared/TermsPopUp/termsPopUp'

const DownloadSongPage = (props) => {
  const [showBusinessTonePopUp, setShowBusinessTonePopUp] = useState(false);
  const [isShowTermsPopup, setIsShowTermsPopup] = useState(false);
  const [isFinishedGetData, setIsFinishedGetData] = useState(false);

  useExtendedEffect((runSideEffects) => {
    window.scrollTo(0, 0);
    if(!props.isFinishedGetSubscribers){
      getSubscribers();
    }
    if (runSideEffects()) {
      props.setTitle({titleBold: "בחירת המתנה נעימה" , titleRegular: ""})
      props.pageLoaded();
    }
  }, []);

  async function getSubscribers() {
    await props.getSubscribers();
    props.pageLoaded();
}

  useEffect(() => {
    if(props.isFinishedGetSubscribers){
      if(props.subscribers.length == 0){
        props.hideAppLoader();
        props.setErrorType({errorType: "GENERAL"})
        props.goToPage({page: 'errorPage'});
      }
      else if(((!props.subscriber && props.subscribers.length > 1)|| ( props.subscribers.length > 1 && props.subscriber && props.subscriber.fundialSubscriberStatus == "SUSPENDED" ))){
        props.hideAppLoader();
        props.goToPage({page: 'subscriberListPage'});
      }
      else if(props.subscriber?.isBusinessTone && props.subscriber?.isBusinessToneLock ){
        props.hideAppLoader();
        props.setErrorType({errorType: "SUBSCRIBER_ERROR"})
        props.goToPage({page: 'errorPage'});
      }
      else if(props.subscriber){
        async function getAoc() {
          setIsFinishedGetData(false);
          props.showAppLoader();
          var result = await props.getAoc({subscriber: props.subscriber.cli , productId: props.selectedSong.id  })
          props.hideAppLoader();
          setIsFinishedGetData(true);
            if(result.payload.results.aocDetails.aocError != null){
              setErrorPage(result.payload.results.aocDetails.aocError);
            }
            else if (result.payload.errorCode == 0){
              if(props.subscriber.isBusinessTone && !props.subscriber.isBusinessToneLock){
                props.reportAnalytics({
                  eventCategory: 'fundial',
                  eventAction: "HN_BusinessTone_reveald",
                  eventLabel: "",
                });
                setShowBusinessTonePopUp(true);
              }
            }
          }
        getAoc();
      }
  }

  }, [props.subscribers]);

  function setErrorPage(errorCode){
    switch(errorCode){
      case "1":
      case "2":
      case "3":
      case "4":
      case "5":
      case "6":
      case "7":
      case "10":
      case "99":
      case "1000":
        props.setErrorType({errorType: "SONG_ERROR"})
        props.goToPage({page: 'errorPage'});
        break;
      case "21":
      case "22":
      case "23":
      case "24":
        props.setErrorType({errorType: "SUBSCRIBER_ERROR"})
        props.goToPage({page: 'errorPage'});
        break;
      case "8":
      case "9":
      case "20":
        props.setErrorType({errorType: "SONG_EXIST"})
        props.goToPage({page: 'errorPage'});
        break;
      default:
        props.setErrorType({errorType: "GENERAL"})
        props.goToPage({page: 'errorPage'});
    }
  }


  async function purchaseSong(orderId) {
    props.showAppLoader();
    var result = await props.purchaseSong({subscriber: props.subscriber.cli , orderString: orderId, isDefault: props.aocDetails.isFirstSong });
    props.hideAppLoader();
    if(result.payload.errorCode == 0) props.goToPage({page: 'downloadedSetupPage'});
 }

  function downloadSong(){
    let orderId = null;
    switch(props.aocDetails.fundialPurchaseType){
      case "PremiumItem":
        props.reportAnalytics({
          eventCategory: 'fundial',
          eventAction: "HN_DownloadSongPagePrimum_Download",
          eventLabel: "",
        });
        orderId = props.aocDetails.premiumOrderString;
        break;
      case "NewCustomerPremiumItem":
      case "NewCustomerRegularItem":
      case "NewCustomerRegularItemAndPremiumItemOptions":
        props.reportAnalytics({
          eventCategory: 'fundial',
          eventAction: "HN_DownloadSongPageNew_Download",
          eventLabel: "",
        });
        orderId = props.aocDetails.premiumOrderString;
        break;
      case "RegularItem":
      case "RegularItemWithPremiumItemUpgradeOptions":
        props.reportAnalytics({
          eventCategory: 'fundial',
          eventAction: "HN_DownloadSongPageUG_Download",
          eventLabel: "",
        });
        orderId = props.aocDetails.orderString;
        break;
      default:
        break;
    }
    if(orderId){
      purchaseSong(orderId);
    }
    else{
      props.setErrorType({errorType: "SONG_ERROR"})
      props.goToPage({page: 'errorPage'});
    }
  }

  function upgradeAndDownloadSong(){
    props.reportAnalytics({
      eventCategory: 'fundial',
      eventAction: "HN_DownloadSongPageUG_Upgrade",
      eventLabel: "",
    });
    purchaseSong(props.aocDetails.premiumOrderString);
  }

  function clickContinueBtnBusinessTone(){
    props.reportAnalytics({
      eventCategory: 'fundial',
      eventAction: "HN_BusinessTone_Continue",
      eventLabel: "",
    });
    setShowBusinessTonePopUp(false);
  }


  return (
    <div className='download-song-page'>
      {props.aocDetails && isFinishedGetData &&
      <>
        <SongSubscriptionSelector
          audio={props.selectedSong}
          fundialSubscriberData={props.aocDetails}
          downloadSong={downloadSong}
          upgradeToUnlimited={upgradeAndDownloadSong}
        />
        <a href="#" className="link-terms" style={{display: 'block', fontSize: '19px',color: "#711769" , marginTop: "20px", textDecoration: 'underline'  }} onClick={() => setIsShowTermsPopup(true)}>למחירון ותנאי שירות</a>
      </>
      }
      <TermsPopUp showPopUp={isShowTermsPopup} closePopUp={() => setIsShowTermsPopup(false)} />
      <BusinessDownloadSongPopUp
      showPopUp={showBusinessTonePopUp}
      closePopUp={() => { setShowBusinessTonePopUp(false) }}
      continueBtn= {() => { clickContinueBtnBusinessTone() }}
      songId={props.selectedSong.id}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    subscriber: state.fundialPage.selectedSubscriber,
    subscribers: state.fundialPage.subscribers,
    selectedSong: state.fundialPage.selectedSong,
    aocDetails: state.fundialPage.aocDetails,
    isFinishedGetSubscribers: state.fundialPage.isFinishedGetSubscribers,
  };
};

const mapDispatchToProps = {
  goToPage,
  setTitle,
  getAoc,
  showAppLoader,
  hideAppLoader,
  purchaseSong,
  setErrorType,
  pageLoaded,
  getSubscribers,
  reportAnalytics
};

export default connect(mapStateToProps, mapDispatchToProps)(DownloadSongPage);
